import Api from '../../../api/addition/summaryAdditionApi';

export default {
  namespaced: true,
  state: {
    addition: {active: false}
  },
  mutations: {
    setAddition(state, {addition}) {
      state.addition = addition;
    }
  },
  actions: {
    async fetchAll({dispatch}) {
      try {
        const response = await Api.fetchAll();
        return Promise.resolve(response.data);
      } catch(error) {
        await dispatch('NOTIFY_ERROR', error, {root: true});
        return Promise.reject(error);
      }
    },
    async fetch({dispatch, commit}, {id}) {
      try {
        const response = await Api.fetch(id);
        commit('setAddition', { addition: response.data });
        return Promise.resolve(response.data);
      } catch(error) {
        await dispatch('NOTIFY_ERROR', error, {root: true});
        return Promise.reject(error);
      }
    },

    async create({dispatch}, data) {
      try {
        const response = await Api.create(data);
        dispatch('NOTIFY_MSG', 'addition.notification.save',
          { root: true});

        return Promise.resolve(response.data);
      } catch(error) {
        await dispatch('NOTIFY_ERROR', error, {root: true});
        return Promise.reject(error);
      }
    },
    async update({dispatch}, data) {
      try {
        const response = await Api.update(data);
        dispatch('NOTIFY_MSG', 'addition.notification.save',
          { root: true});

        return Promise.resolve(response.data);
      } catch(error) {
        await dispatch('NOTIFY_ERROR', error, {root: true});
        return Promise.reject(error);
      }
    },
    async delete({dispatch}, {additionId}) {
      try {
        await Api.delete(additionId);
        await dispatch('NOTIFY_MSG', 'addition.notification.delete',
          { root: true});
        return Promise.resolve();
      } catch(error) {
        await dispatch('NOTIFY_ERROR', error, {root: true});
        return Promise.reject(error);
      }
    },
    async copy({dispatch}, {summaryAdditionId}) {
      try {
        await Api.copy(summaryAdditionId);
        await dispatch('NOTIFY_MSG', 'addition.notification.copy',
          { root: true});
        return Promise.resolve();
      } catch(error) {
        await dispatch('NOTIFY_ERROR', error, {root: true});
        return Promise.reject(error);
      }
    }
  }
}
